/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Language_Pt_BrInputs */

const en_us2_profile_language_pt_br = /** @type {(inputs: Profile_Language_Pt_BrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português (Brasil)`)
};

const pt_br2_profile_language_pt_br = /** @type {(inputs: Profile_Language_Pt_BrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português (Brasil)`)
};

const es_419_profile_language_pt_br = /** @type {(inputs: Profile_Language_Pt_BrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português (Brasil)`)
};

const pt_pt2_profile_language_pt_br = /** @type {(inputs: Profile_Language_Pt_BrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português (Brasil)`)
};

const fr_fr2_profile_language_pt_br = /** @type {(inputs: Profile_Language_Pt_BrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português (Brasil)`)
};

const de_de2_profile_language_pt_br = /** @type {(inputs: Profile_Language_Pt_BrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português (Brasil)`)
};

const it_it2_profile_language_pt_br = /** @type {(inputs: Profile_Language_Pt_BrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português (Brasil)`)
};

/**
* | output |
* | --- |
* | "Português (Brasil)" |
*
* @param {Profile_Language_Pt_BrInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_language_pt_br = /** @type {((inputs?: Profile_Language_Pt_BrInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Language_Pt_BrInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_language_pt_br(inputs)
	if (locale === "es-419") return es_419_profile_language_pt_br(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_language_pt_br(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_language_pt_br(inputs)
	if (locale === "de-DE") return de_de2_profile_language_pt_br(inputs)
	if (locale === "it-IT") return it_it2_profile_language_pt_br(inputs)
	return en_us2_profile_language_pt_br(inputs)
});
export { profile_language_pt_br as "profile.language_pt_br" }